// extracted by mini-css-extract-plugin
module.exports = {"newPasswordWithCriteria":"NewPasswordWithCriteria_newPasswordWithCriteria__THCJp"};